/**
 * Returns a data-testid value only in non-production builds.
 *
 * In production (`VITE_APP_BUILD === 'prod'`) it returns `undefined`, so Svelte
 * omits the attribute entirely and no test ids leak into the production DOM.
 * In every other environment (staging, alpha, gamma, ...) the id is rendered so
 * Playwright can target elements via `page.getByTestId(...)`.
 */
export const testId = (id: string): string | undefined =>
	import.meta.env.VITE_APP_BUILD !== 'prod' ? id : undefined;
